<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-morning-star">
<h1>The Morning Star</h1>
<p style="text-indent:0em">The sky is clear after new rain</p>
<p style="text-indent:0em">The clouds have given space</p>
<p style="text-indent:0em">And I am in the Morning Star’s one would have to say</p>
<p style="text-indent:0em">Cold embrace</p>
<p style="text-indent:0em">Even walking back with my back to it</p>
<p style="text-indent:0em">There it is in unexpected places</p>
<p style="text-indent:0em">In my hand and on my brow</p>
<p style="text-indent:0em">And a light to upturned faces</p><br/>
<p style="text-indent:0em">Run your finger up the side of the frame</p>
<p style="text-indent:0em">Smooth as it is</p>
<p style="text-indent:0em">You couldn’t work out how</p>
<p style="text-indent:0em">To slide your finger over onto the top of the frame</p>
<p style="text-indent:0em">It sounds ridiculous I know</p>
<p style="text-indent:0em">Couldn’t order it in your head, the steps</p>
<p style="text-indent:0em">It was too hard</p>
<p style="text-indent:0em">You were locked</p>
<p style="text-indent:0em">Then one day the muscles lined up</p>
<p style="text-indent:0em">We say the stars lined up but it was just practice</p>
<p style="text-indent:0em">And you got over</p>
<p style="text-indent:0em">The right was with you</p>
<p style="text-indent:0em">Since then you can do it easily every time</p>
<p style="text-indent:0em">Out of the vertical comes the horizontal</p>
<p style="text-indent:0em">The horizontal is the new vertical</p>
<p style="text-indent:0em">And vertical no more</p>
<p style="text-indent:0em">It is flat far ahead</p>
<p style="text-indent:0em">Flatness you could rent a house on</p>
<p style="text-indent:0em">It is narrow you decide to walk it</p>
<p style="text-indent:0em">Nothing between you and the sky</p>
<p style="text-indent:0em">Which just means there is no weather</p>
<p style="text-indent:0em">Nothing-phenomena</p>
<p style="text-indent:0em">You head off</p>
<p style="text-indent:0em">Mesmerised by the narrow line you must tread</p>
<p style="text-indent:0em">So thin and balancing</p>
<p style="text-indent:0em">You don’t want to look to right and left</p>
<p style="text-indent:0em">Right and left is up and down</p>
<p style="text-indent:0em">You will fall to your doom</p>
<p style="text-indent:0em">You are uncomfortable in high places</p>
<p style="text-indent:0em">Although your reach is reachless</p>
<p style="text-indent:0em">You are said to be reaching beyond your reach</p>
<p style="text-indent:0em">Where it is too dark to see</p>
<p style="text-indent:0em">Where the natural failings of your poor eyesight</p>
<p style="text-indent:0em">Turn the near distance into mush</p><br/>
<p style="text-indent:0em">You draw a picture of it</p>
<p style="text-indent:0em">Slowly as you work at your drawing</p>
<p style="text-indent:0em">It becomes a photograph</p>
<p style="text-indent:0em">It is not an impossible photograph</p>
<p style="text-indent:0em">Of one who lived before the invention of photography</p>
<p style="text-indent:0em">No, it started from a drawing</p>
<p style="text-indent:0em">Became a photograph</p>
<p style="text-indent:0em">But never was an invention</p>
<p style="text-indent:0em">Hanging it on the wall</p>
<p style="text-indent:0em">And after many years of watching each other</p>
<p style="text-indent:0em">You guess your face relaxed first</p>
<p style="text-indent:0em">Then the face in the photograph</p>
<p style="text-indent:0em">Who is not me by the way</p>
<p style="text-indent:0em">And loosened up and</p>
<p style="text-indent:0em">Smiled</p>
<p style="text-indent:0em">And we became closer</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?402acd27